var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"register-wrapper"},[_c('title-bar',{attrs:{"title":"注册"}}),_c('div',{staticClass:"register-iframe"},[_c('iframe',{staticClass:"lanhu-register",attrs:{"marginheight":"4.5rem","src":`https://${_vm.domain}.com/mobile/#/register`,"frameborder":"0"}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }